export default "__VITE_ASSET__Bc7urFtq__"